import { ProcessSelectionActionType, ProcessSelectionConfiguration } from './../../tmc-common/widgets/terminal/process-selection/process-selection.model';
import { MatLegacyDialog as MatDialog }from '@angular/material/legacy-dialog';
import { FlowStepHandleResult, HandleResultType, StepControl, AbstractStepController, StepControlType, WizardServiceLocator } from '@sdbn/appclient';
import { ContextChange } from '@sdbn/appclient';
import { ConfirmDialogComponent, ConfirmDialogData } from 'src/app/shared/confirm-dialog/confirm.dialog.component';
import { LogContainer } from 'src/tmc-common/model/log-container.model';
import { TerminalContextConstants } from 'src/tmc-common/model/terminal-context-constants';
import { ProcessSelectOption } from 'src/tmc-common/widgets/terminal/process-selection/process-selection.model';
import { HttpService } from '@sdbn/appclient';

export class OnlineterminalCalculateProcessOptionsController extends AbstractStepController {

  private httpService: HttpService;

  selectOptions = new Array<ProcessSelectOption>();


  onContextChange(contextChange: ContextChange) {
    if (contextChange.key === 'selectedProcessOption' && contextChange.value != null) {
      this.handleSelectedProcessOption(this.dashboardContext.getContextValue('selectedProcessOption'));
    }
  }

  onRegisterToDashboardContext() {
    this.httpService = WizardServiceLocator.injector.get(HttpService);
    this.dashboardContext.setContextValue('selectedProcessOption', null);
    this.dashboardContext.setContextValue('dashboardConfiguration', null);
    this.calculateAvailableProcessOptions();
  }

  public handleFlow(): FlowStepHandleResult {
    this.wizardComponent.startInactivityMonitoring();
    const logContainer: LogContainer = this.dashboardContext.context.get(TerminalContextConstants.logContainer);
    logContainer.addLog('onlineterminal calculate available process options started');

    const result = new FlowStepHandleResult();
    result.type = HandleResultType.DASHBOARD;
    return result;
  }

  private cancel() {
    const matDialog = WizardServiceLocator.injector.get(MatDialog);
    const dialogData: ConfirmDialogData = {
      titleKey: 'tmc-yard.widgets.registration-terminal.cancel-dialog.title',
      messageKey: 'tmc-yard.widgets.registration-terminal.cancel-dialog.message',
      confirm: () => {
        this.wizardComponent.stopInactivityMonitoring();
        this.wizardComponent.restartWizard();
      }
    };
    matDialog.open(ConfirmDialogComponent, {
      data: dialogData
    });
  }

  getControls(): StepControl[] {
    const controls = new Array<StepControl>();

    const spacer = new StepControl();
    spacer.type = StepControlType.SPACER_GROW;
    controls.push(spacer);

    const cancelControl = new StepControl();
    cancelControl.labelDictionaryKey = 'tmc-yard.widgets.registration-terminal.button.cancel';
    cancelControl.type = StepControlType.BUTTON_STROKED;
    cancelControl.iconBeforeCss = 'fa-thin fa-xmark';
    cancelControl.controlAction = this.cancel.bind(this);
    controls.push(cancelControl);

    return controls;
  }

  private handleSelectedProcessOption(selectedProcessOption: ProcessSelectOption) {
    this.wizardComponent.stopInactivityMonitoring();
    if (selectedProcessOption.actionType === ProcessSelectionActionType.PROCESS_FLOW) {
      this.wizardComponent.handoverToFlow(selectedProcessOption.processFlowKey);
    } else if (selectedProcessOption.actionType === ProcessSelectionActionType.PROCESS_STEP) {
      this.wizardComponent.next(selectedProcessOption.processStepKey);
    } else {
      console.error('Invalid ProcessSelectionActionType' + selectedProcessOption.actionType);
    }
  }


  private calculateAvailableProcessOptions() {
    const instructionsDone = this.dashboardContext.getContextValue('instructionsDone');
    const inviteVisitorsAllowed = this.dashboardContext.getContextValue('inviteAdditionalVisitorsAllowed');
    if (inviteVisitorsAllowed) {
      this.selectOptions.push(new ProcessSelectOption({
        key: 'invite',
        titleDictionaryKey: 'tmc-yard.widgets.registration-terminal.registration-process-selection.step.invite-additional-visitors',
        titleIconCss: 'fa-thin fa-people',
        descriptionDictionaryKey: null,
        processFlowKey: this.resolveProcessStepKey('inviteAdditionalVisitor'),
        actionType: ProcessSelectionActionType.PROCESS_FLOW
      }));
    }
    if (instructionsDone) {
      if(this.resolveProcessStepKey('printRegistrationQRCode') != null) {
      this.selectOptions.push(new ProcessSelectOption({
        key: 'print-code',
        titleDictionaryKey: 'tmc-yard.widgets.registration-terminal.registration-process-selection.step.print-registration-qrcode',
        titleIconCss: 'fa-thin fa-qrcode',
        descriptionDictionaryKey: null,
        processFlowKey: this.resolveProcessStepKey('printRegistrationQRCode'),
        actionType: ProcessSelectionActionType.PROCESS_FLOW
      }));
    }
    } else {
      this.selectOptions.push(new ProcessSelectOption({
        key: 'instructions',
        titleDictionaryKey: 'tmc-yard.widgets.registration-terminal.registration-process-selection.step.start-instructions',
        titleIconCss: 'fa-thin fa-chalkboard-user',
        descriptionDictionaryKey: null,
        processFlowKey: this.resolveProcessStepKey('startInstructions'),
        actionType: ProcessSelectionActionType.PROCESS_FLOW
      }));
    }
    this.dashboardContext.setContextValue('dashboardConfiguration',
        new ProcessSelectionConfiguration({ selectOptions: this.selectOptions }));
  }

  private resolveProcessStepKey(key: string) {
    const config = this.wizardComponent.currentStep.dashboardConfiguration?.flowMapping;
    return config[key];
  }

}
